import { render } from "./ErrorMessage.vue?vue&type=template&id=7ae3c6a8"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/berisalam-console/webapps/berisalam-console/releases/1793606032384/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__